import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageStage728x90Gak from './gak/DesktopDevPageStage728x90';
import DesktopDevPageArtStage from './primis/DesktopDevPageArtStage';
import DesktopDevPageStage728x90Fs from './freestar/DesktopDevPageStage728x90';
const DesktopDevPageStage728x90 = ({ safety ='off'  })=>{
    const isPrimis = useFlag('ads_primis_top');
    const primisOff = useFlag('ads_primis_perf');
    const isFreestar = useFlag('ads_freestar');
    if (!primisOff && isPrimis) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageArtStage, {
            safety: safety
        });
    }
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Fs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Gak, {
        safety: safety
    });
};
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
